import { type HttpHandler, type HttpInterceptor, type HttpRequest } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Router } from '@angular/router'
import { ENV_DEMO_BYPASS_AUTH } from '@core/util/env.util'
import { NOOP } from '@core/util/functional.util'
import { TO_STRING } from '@core/util/string.util'
import { AuthService } from './auth.service'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  AuthService = inject(AuthService)
  Router = inject(Router)

  intercept (req: HttpRequest<any>, next: HttpHandler): any {
    let req2 = req

    if (this.AuthService.checkJwt()) {
      const jwt = TO_STRING(this.AuthService.getJwt())
      req2 = req.clone({ headers: req.headers.set('Authorization', `Bearer ${jwt}`) })
    } else if (!ENV_DEMO_BYPASS_AUTH) {
      // demo build : no real login page to fall back to (the auto-login initializer fetches the JWT), so skip the redirect
      this.Router.navigateByUrl('/login').catch(NOOP)
    }

    return next.handle(req2)
  }
}
